import {useContext} from 'react';
import type {Component} from 'grapesjs';
import {formMakerContext} from '@FormMakerReact/form-maker.context';

export function useSelectedComponent(): Component | null {
  const {state} = useContext(formMakerContext);
  return state.selectedComponent;
}
